import { render, staticRenderFns } from "./TransactionsDownloadView.vue?vue&type=template&id=2b737948&"
import script from "./TransactionsDownloadView.vue?vue&type=script&lang=js&"
export * from "./TransactionsDownloadView.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports